/**
 * As três contas básicas do sistema. Cada uma devolve uma fração
 * (0,223 = 22,3%) ou null quando a conta não faz sentido (divisão por zero).
 *
 * Lê: nada.
 * Usado por: dominio/painel.ts.
 */

/** Participação: quanto o valor representa do total. Ex.: 17.373,10 ÷ 85.106,95 = 0,204. */
export function participacao(valor: number, total: number): number | null {
  return total === 0 ? null : valor / total;
}

/** Atingimento: quanto da meta já foi feito. Ex.: 15.139,76 ÷ 68.000 = 0,223. */
export function atingimento(realizado: number, meta: number): number | null {
  return meta > 0 ? realizado / meta : null;
}

/**
 * Projeção para o fim do mês, no ritmo atual (regra J):
 * realizado ÷ dias úteis passados × dias úteis do mês.
 * Ex.: 15.139,76 ÷ 7 × 21 = 45.419,28.
 */
export function projetar(realizado: number, dias: { passados: number; total: number }): number | null {
  return dias.passados === 0 ? null : (realizado / dias.passados) * dias.total;
}
